import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors, fontStyles } from '../../../styles';
import { ToolRendererProps } from './types';
import { formatDate } from './shared/utils';
import { DataCard } from './shared/DataCard';

export const NewsRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          ${fontStyles.mouse}
          color: ${colors.silver};
        `}
      >
        Fetching latest news...
      </div>
    );
  }

  let newsData;
  let articles: any[] = [];

  try {
    newsData = output.news?.data || output.data || output.articles;

    if (!newsData) {
      return (
        <div
          css={css`
            ${fontStyles.mouse}
            color: ${colors.silver};
          `}
        >
          News retrieved
        </div>
      );
    }

    if (Array.isArray(newsData)) {
      articles = newsData.slice(0, 6);
    } else if (typeof newsData === 'object') {
      articles = Object.values(newsData).flat().slice(0, 6) as any[];
    }
  } catch (error) {
    console.error('Failed to parse news data:', error);
    return (
      <div
        css={css`
          ${fontStyles.mouse}
          color: ${colors.silver};
        `}
      >
        Error retrieving news
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div
        css={css`
          ${fontStyles.mouse}
          color: ${colors.silver};
        `}
      >
        No news articles found
      </div>
    );
  }

  return (
    <div
      css={css`
        margin: ${spacing.centi} 0 0 0;
      `}
    >
      {articles.map((article: any, index: number) => (
        <div
          key={index}
          css={css`
            margin-bottom: ${spacing.deci};
          `}
        >
          <DataCard padding={spacing.centi}>
            <div
              css={css`
                line-height: 1.4;
              `}
            >
              <div
                css={css`
                  ${fontStyles.cat}
                  color: ${colors.petrolBlue};
                  margin-bottom: ${spacing.micro};
                  cursor: pointer;
                  text-decoration: none;

                  &:hover {
                    text-decoration: underline;
                  }

                  html[data-theme='dark'] & {
                    color: ${colors.skyBlue};
                  }
                `}
                onClick={() => {
                  const query = encodeURIComponent(article.title || article.headline || 'News update');
                  const googleSearchUrl = `https://www.google.com/search?q=${query}`;
                  window.open(googleSearchUrl, '_blank', 'noopener,noreferrer');
                }}
              >
                {article.title || article.headline || 'News update'}
              </div>
              {(article.updated || article.created || article.publishedAt || article.date) && (
                <div
                  css={css`
                    ${fontStyles.flea}
                    color: ${colors.silver};
                    font-family: monospace;
                    font-variant-numeric: tabular-nums;
                  `}
                >
                  {formatDate(article.updated || article.created || article.publishedAt || article.date)}
                </div>
              )}
            </div>
          </DataCard>
        </div>
      ))}
    </div>
  );
};
